import { render } from "./EmailProcessor.vue?vue&type=template&id=6a2f0ae4"
import script from "./EmailProcessor.vue?vue&type=script&lang=js"
export * from "./EmailProcessor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__